var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5118 4.15199L14.6799 2.98386C15.3251 2.33871 16.3711 2.33871 17.0162 2.98386C17.6613 3.629 17.6613 4.67498 17.0162 5.32012L15.8481 6.48826M13.5118 4.15199L9.15025 8.51358C8.27919 9.38467 7.84363 9.82016 7.54706 10.3509C7.25047 10.8817 6.95208 12.1349 6.66675 13.3333C7.86516 13.048 9.11842 12.7496 9.64917 12.453C10.1799 12.1564 10.6154 11.7209 11.4865 10.8498L15.8481 6.48826M13.5118 4.15199L15.8481 6.48826",
    stroke: "#FF5C3C",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10C17.5 13.5355 17.5 15.3033 16.4017 16.4017C15.3033 17.5 13.5355 17.5 10 17.5C6.46447 17.5 4.6967 17.5 3.59835 16.4017C2.5 15.3033 2.5 13.5355 2.5 10C2.5 6.46447 2.5 4.6967 3.59835 3.59835C4.6967 2.5 6.46447 2.5 10 2.5",
    stroke: "#FF5C3C",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilEdit);
export default __webpack_public_path__ + "static/media/pencil-edit.ddb62fa14df037cb7e56080691272a97.svg";
export { ForwardRef as ReactComponent };